import IfStart from './IfStart';
import Else_ from './Else_';
import IfEnd from './IfEnd';

export default IfStart;

export {
  Else_,
  IfEnd,
}
